import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";

const Layout: React.FC = () => {
	const location = useLocation();

	// 管理者ダッシュボードかどうかを判定
	// /organizer/* （主催者管理画面）はヘッダー非表示
	// ただし /organizer/register と /organizers/* （主催者プロフィール）は除外してヘッダー表示
	const path = location.pathname;
	const isOrganizerDashboard = path === '/organizer' ||
	                             (path.startsWith('/organizer/') &&
	                              !path.startsWith('/organizers/') &&
	                              !path.startsWith('/organizer/register') &&
	                              !path.startsWith('/organizer/start'));

	// ホームページ・主催者LPはフルブリードレイアウト（各セクションが独自にコンテナ幅を制御）
	const isHomePage = path === '/' || path === '/home';
	const isOrganizerLP = path === '/organizer/start';
	const isFullWidthPage = isHomePage || isOrganizerDashboard || isOrganizerLP;

	return (
		<div className="min-h-screen flex flex-col">
			{/* Header - 管理者ダッシュボードでは非表示 */}
			{!isOrganizerDashboard && <Header />}

			{/* Main Content */}
			<main className={`flex-grow ${!isFullWidthPage ? 'container mx-auto px-4 py-8' : ''}`}>
				<Outlet />
			</main>

			{/* Footer - 管理者ダッシュボードでは非表示 */}
			{!isOrganizerDashboard && <Footer />}
		</div>
	);
};

export default Layout;
